import React from 'react'
import { NavLink } from 'react-router-dom'
import colors from '../utils/colors'

const NavigationItem = ({icon,path,title}) => {
    return (
        <NavLink to={path} className={({isActive})=>(isActive?`side-bar-item ${colors.lightPrimary} rounded-[10px] text-[#f77f00]`:'side-bar-item')}>
        {({isActive})=>(
            <>
            <div className={isActive?` mr-[10px] text-[${colors.primary}]`:"mr-[10px]"}>
              {icon}
          </div>
          <div className={isActive?`text-[${colors.primary}]`:""}>{title}</div>
          </>
        )}
        </NavLink>
    )
}

export default NavigationItem
